import {
  ActionCategory,
  ActionTransactionSubType,
  ActionTransactionSubTypes,
  ActionType,
} from 'further-types/lp/action';
import {
  ActionTransactionSubTypeLabels,
  ActionTypeLabels,
} from 'further-ui/labels';

export const getActionLabel = (row: {
  actionCategory?: ActionCategory | null;
  actionType: ActionType;
  transactionSubType: ActionTransactionSubType;
  customActionType?: string | null;
  debitTransactionTypeId?: string | null;
  creditTransactionTypeId?: string | null;
}) => {
  switch (row.actionCategory) {
    case ActionCategory.FX:
      return overrideFxCategoryLabel(row);
    case ActionCategory.CapitalActions: {
      return composeSubTypeLabel(row);
    }
    case ActionCategory.Realisation:
      return overrideRealisationCategoryLabel(row);
    default:
      return `${
        row.customActionType
          ? row.customActionType
          : ActionTypeLabels[row.actionType]
      } ${showTransactionSubType(row.transactionSubType)}`;
  }
};

export const overrideFxCategoryLabel = (row: {
  transactionSubType: ActionTransactionSubType;
  actionType: ActionType;
}) => {
  switch (row.transactionSubType) {
    case ActionTransactionSubTypes.FXGainPayable:
      return 'Unrealised FX Gain (FX Gain on payable)';
    case ActionTransactionSubTypes.FXLossPayable:
      return 'Unrealised FX Loss (FX Loss on payable)';
    case ActionTransactionSubTypes.FXGainReceivable:
      return 'Unrealised FX Gain (Fx Gain on receivable)';
    case ActionTransactionSubTypes.FXLossReceivable:
      return 'Unrealised FX Loss (Fx Loss on receivable)';
    case ActionTransactionSubTypes.UnrealisedAssetFXGain:
      return 'Unrealised Asset FX Gain (Unrealised Asset FX Gain)';
    case ActionTransactionSubTypes.UnrealisedAssetFXLoss:
      return 'Unrealised Asset FX Loss (Unrealised Asset FX Loss)';
    case ActionTransactionSubTypes.UnrealisedCashFXGain:
      return 'Unrealised Cash FX Gain (Unrealised Cash FX Gain)';
    case ActionTransactionSubTypes.UnrealisedCashFXLoss:
      return 'Unrealised Cash FX Loss (Unrealised Cash FX Loss)';
    default:
      return composeSubTypeLabel(row);
  }
};

export const overrideRealisationCategoryLabel = (row: {
  transactionSubType: ActionTransactionSubType;
  actionType: ActionType;
  debitTransactionTypeId?: string | null;
  creditTransactionTypeId?: string | null;
}) => {
  switch (row.transactionSubType) {
    case ActionTransactionSubTypes.UnrealisedGainsUnwind:
      return isDebit(row)
        ? 'Unrealised gains unwind (Unrealised gain debit)'
        : 'Unrealised gains unwind (Appreciation/depreciation credit)';
    case ActionTransactionSubTypes.UnrealisedLossesUnwind:
      return isDebit(row)
        ? 'Unrealised losses unwind (Appreciation/depreciation debit)'
        : 'Unrealised losses unwind (Unrealised loss credit)';
    default:
      return showTransactionSubType(row.transactionSubType);
  }
};

const composeSubTypeLabel = (row: {
  transactionSubType: ActionTransactionSubType;
  actionType: ActionType;
}) => {
  const subTypeLabel = showTransactionSubType(row.transactionSubType);
  return subTypeLabel
    ? `${ActionTypeLabels[row.actionType]} (${subTypeLabel})`
    : ActionTypeLabels[row.actionType];
};

const showTransactionSubType = (
  transactionSubType: ActionTransactionSubType,
) => {
  switch (transactionSubType) {
    case ActionTransactionSubTypes.CreditDebitPair:
      return '';
    default:
      return `${ActionTransactionSubTypeLabels[transactionSubType]}`;
  }
};

const isDebit = (row: {
  debitTransactionTypeId?: string | null;
  creditTransactionTypeId?: string | null;
}) => {
  return (
    row.debitTransactionTypeId !== null && row.creditTransactionTypeId === null
  );
};
